import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    userInfo: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        marginLeft: 'auto',

        '& p': {
            margin: '0 10px',
            fontSize: '16px',
            color: '#444',

            '&:hover': {
                color: theme.palette.primary.main,
            },

            [theme.breakpoints.down('md')]: {
                margin: '0 7px',
                fontSize: '14px',
            },
        },
    },
    rounded: {
        color: '#fff',
        backgroundColor: theme.palette.primary.main,
        fontSize: '16px',
        [theme.breakpoints.down('md')]: {
            width: '36px',
            height: '36px',
        },
    },
    downIcon: {
        color: theme.palette.secondary.main,
    },
}));
